import { COLOR_OPTIONS } from 'config/style/color-options';
import styled from 'styled-components';

export const HighLevelStatisticsBox = styled.div`
  flex: 1;
  padding: 16px 6px 16px 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (max-width: 768px) {
    overflow: visible;
    padding: 12px;
  }
`;

export const List = styled.div`
  margin-top: 8px;
  padding-right: 6px;
  flex: 1;
  overflow-y: scroll;
  height: 100%;

  @media (max-width: 768px) {
    overflow-y: visible;
    height: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const Item = styled.div`
  padding: 8px;
  border: 1px solid #dfe2e7;
  border-radius: 4px;
  margin-bottom: 8px;

  div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &:last-child {
    margin-bottom: 25px;
  }
`;

export const RiskLegend = styled.div<{ width: string; backgroundColor?: string }>`
  & {
    width: 100%;
    height: 8px;
    margin-bottom: 4px;
    background-color: #f3f4f6;
    border-radius: 212px;
  }
  &:before {
    content: '';
    width: ${props => props.width}%;
    height: 8px;
    background-color: ${props => props.backgroundColor ?? COLOR_OPTIONS.NEUTRAL_70};
    display: flex;
    border-radius: 212px;
  }
`;
